import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import ModalPortal from '../../../components/modal-portal';

import AutoRoutingConfigurationModalBody from './smart-routing-registration/auto-routing-configuration-modal-body';

import messages from './messages';
import style from './style.module.less';

const ConfirmEnableSmartRouting = ({ handleContinueEnablingSmartRouting, onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal className={style['enable-smart-routing-modal']} size='medium'>
        <ModalHeader>
          <FormattedMessage {...messages.confirmationTitleWhenEnablingSmartRouting} />
        </ModalHeader>
        <AutoRoutingConfigurationModalBody handleContinueEnablingSmartRouting={handleContinueEnablingSmartRouting} />
      </Modal>
    </ModalPortal>
  );
};

ConfirmEnableSmartRouting.propTypes = {
  handleContinueEnablingSmartRouting: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmEnableSmartRouting;
